// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"2a9e1789","802":"a7443d4c"}[chunkId] + ".chunk.js";
};